import {
  EXPERT_CREDENTIALS_RESPONSE,
  EXPERT_CREDENTIALS_FAILURE,
  EXPERT_CREDENTIALS_REQUEST,
  CLEAR_EXPERT_BIO_RESULTS,
  UPDATE_EXPERT_BIO_CREDENTIALS
} from "../../actions/types";
import { combineReducers } from "redux";

import ExpertPrevAffiliationReducer from "./ExpertPrevAffiliationReducer";
import ExpertArticlesReducer from "./ExpertArticlesReducer";
import ExpertHistogramReducer from "./ExpertHistogramReducer";
import ExpertExternalLinkReducer from "./ExpertExternalLinksReducer";
import ExpertTrialReducer from "./ExpertTrialReducer";
import ExpertCollabsReducer from "./ExpertCollabsReducer";
import ExpertGrantsReducer from "./ExpertGrantsReducer";
import ExpertMsaArticles from "./ExpertMsaArticles";
import ExpertOpenPayments  from "./ExpertOpenPayments";


const initialState = {
  credentials: {},
  intrests: [],
  keywordRanks: {},
  isFetching: true,
  error: false,
  expertsFullInfo: {}
};

const setFetching = (state, action) => {
  return {
    credentials: {},
    intrests: [],
    keywordRanks: {},
    isFetching: true,
    error: false,
    expertsFullInfo: {}
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    credentials: {},
    intrests: [],
    keywordRanks: {},
    expertsFullInfo: {}
  };
};

const setResults = (state, action) => {
  let credentials = action.payload.credentials || {};
  let intrests = action.payload.intrests || [];
  let keywordRanks = action.payload.keywordRanks || {};
  let expertsFullInfo = action.payload.expertsFullInfo || {};

  return {
    ...state,
    isFetching: false,
    error: false,
    credentials,
    intrests,
    keywordRanks,
    expertsFullInfo
  };
};

const updatedCredentials = (state, action) => {
  let { expertsFullInfo } = action.payload;

  return {
    ...state,
    expertsFullInfo
  };
};

const ExpertCredentialsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPERT_CREDENTIALS_RESPONSE:
      return setResults(state, action);
      break;

    case EXPERT_CREDENTIALS_FAILURE:
      return setFailure(state, action);
      break;

    case EXPERT_CREDENTIALS_REQUEST:
      return setFetching(state, action);

    case UPDATE_EXPERT_BIO_CREDENTIALS:
      return updatedCredentials(state, action);

    case CLEAR_EXPERT_BIO_RESULTS:
      return initialState;

    default:
      return state;
      break;
  }
};

export default combineReducers({
  Credentials: ExpertCredentialsReducer,
  ExpertPrevAff: ExpertPrevAffiliationReducer,
  Histogram: ExpertHistogramReducer,
  Articles: ExpertArticlesReducer,
  ExternalLinks: ExpertExternalLinkReducer,
  ClinicalTrials: ExpertTrialReducer,
  ExpertCollabs: ExpertCollabsReducer,
  Grants: ExpertGrantsReducer,
  ExpertMsaArticles: ExpertMsaArticles,
  ExpertOpenPayments: ExpertOpenPayments
});
